import { configureStore, combineReducers } from '@reduxjs/toolkit';
import logger from 'redux-logger';

import * as resourceReducers from './resourceReducers';

import { clearRejectedQueries } from '../global/utils/storeUtils';

// only use logger in development
const middlewares = []
if(process.env.NODE_ENV === `development`) {
  middlewares.push(logger)
}

export const initStore = (loggedInUser = null) => configureStore({
  reducer: rootReducer
  , middleware: (getDefaultMiddleware) => getDefaultMiddleware().concat(...middlewares)
  , preloadedState: {
    auth: {
      // set loggedInUser as preloaded state so the store is created before any auth checks occur.
      loggedInUser: loggedInUser && loggedInUser._id ? loggedInUser : null
      , status: "idle"
      , error: null
      /**
       * 1.13 - this is the static list of all possible SSO providers supported by the app
       * this is used by an admin to set or determine a user's external access
       * only "acrp" previously
       */
      , ssoProviders: [
        "acrp"
        , "yote-test"
        , "ppd"
        , "okta-test"
        , "personalis"
        , "upenn"
        , "dev-test"
        , "auth0-test"
        , "cgm-exostar"
        , "mycme"
        , "healio"
        , "pf-google"
        , "lexitas_sso"
        , "simulations-plus"
        , "scrs_oidc"
      ]
    }
  }
})

const rootReducer = (state, action) => {
  // clear store on logout, also on login so any previous rejected queries are cleared out.
  // 1.14 NOTE: We can't just clear the store on login anymore because now we need to keep the existing state for login via landing page.
  // adapted from https://stackoverflow.com/a/61943631
  if(action.type === 'auth/sendLogout/fulfilled' || action.type === 'auth/sendLogout/rejected') {
    state = undefined
  }
  if(action.type === 'auth/sendLogin/fulfilled') {
    // 1.14 - clear out any rejected queries when the user logs in successfully so they can be re-fetched
    state = clearRejectedQueries(state)
  }
  return combinedReducers(state, action)
}

const combinedReducers = combineReducers({
  ...resourceReducers
})
